export function waitUntil(check, execfunc, timeoutMs) {
    const timeWas = new Date();
    const wait = setInterval(function() {
        if (check() ) {
            execfunc()
            clearInterval(wait);
        } else if (new Date() - timeWas > timeoutMs) { // Timeout
            clearInterval(wait);
        }
    }, 100);
}
